import { __decorate } from "tslib";
import { module } from 'angular';
import { NgModule } from 'angular-ts-decorators';
import { SharedModule } from 'src/shared';
import { DocumentsSpotController } from './documents-spot/documents-spot.controller';
import { DocumentsOverviewComponent } from './document-overview/documents-overview.component';
import { DocumentsOverviewItemsComponent } from './documents-overview-items/documents-overview-items.component';
import { DocumentsOverviewLanguagesComponent } from './documents-overview-languages/documents-overview-languages.component';
import { BytesPipe } from './bytes.pipe';
import { SupportDesignModule } from 'src/Foundation/Design/app';
var moduleId = 'gn.audio.support.documents';
var legacyModuleId = moduleId + ".legacy";
module(legacyModuleId, [])
    .controller('DocumentsSpotController', DocumentsSpotController);
var DocumentsModule = (function () {
    function DocumentsModule() {
    }
    DocumentsModule = __decorate([
        NgModule({
            declarations: [
                DocumentsOverviewComponent,
                DocumentsOverviewItemsComponent,
                DocumentsOverviewLanguagesComponent,
                BytesPipe,
            ],
            id: moduleId,
            imports: [
                legacyModuleId,
                SupportDesignModule,
                SharedModule,
            ],
            providers: [],
        })
    ], DocumentsModule);
    return DocumentsModule;
}());
export { DocumentsModule };
